(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-blog-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBlogTabs(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var sections = scope.querySelectorAll('[data-cp-blog-grid]');
    for (var si = 0; si < sections.length; si++) {
      (function (section) {
        var tabs = section.querySelectorAll('[data-cp-blog-filter]');
        var cards = section.querySelectorAll('[data-cp-blog-handle]');
        if (!tabs.length || !cards.length) return;

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var filter = tab.getAttribute('data-cp-blog-filter');

            tabs.forEach(function (t) {
              t.classList.remove('cp-tab--active');
              t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('cp-tab--active');
            tab.setAttribute('aria-selected', 'true');

            cards.forEach(function (card) {
              var handle = card.getAttribute('data-cp-blog-handle');
              if (filter === 'all' || handle === filter) {
                card.removeAttribute('hidden');
              } else {
                card.setAttribute('hidden', '');
              }
            });
          });
        });
      })(sections[si]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBlogTabs(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initBlogTabs(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sectionOf(el) {
    return el.closest('.cp-collection-grid');
  }

  function fetchSection(url, sectionId) {
    var u = new URL(url, window.location.href);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function pushHistory(url) {
    var u = new URL(url, window.location.href);
    history.pushState({}, '', u.pathname + u.search + u.hash);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // Client-side "Show more" (several source collections)
    var clientLoadMore = e.target.closest('[data-cp-load-more-client]');
    if (clientLoadMore) {
      e.preventDefault();
      var section = sectionOf(clientLoadMore);
      if (!section) return;
      var nav = section.querySelector('[data-cp-nav-client]');
      var next = section.querySelector('.cp-batch[hidden]');
      if (next) {
        next.removeAttribute('hidden');
        if (!section.querySelector('.cp-batch[hidden]') && nav) nav.remove();
      }
      return;
    }

    var loadMore = e.target.closest('[data-cp-load-more]');
    var pageLink = e.target.closest('[data-cp-page-link]');
    if (!loadMore && !pageLink) return;
    e.preventDefault();

    var trigger = loadMore || pageLink;
    var section = sectionOf(trigger);
    if (!section) return;

    var sectionId = section.id.replace('shopify-section-', '');
    var url = trigger.getAttribute('data-cp-load-more') || trigger.getAttribute('data-cp-page-link');
    if (!url) return;

    var nav = section.querySelector('[data-cp-nav]');
    var grid = section.querySelector('.cp-grid');
    if (nav) nav.classList.add('is-loading');

    fetchSection(url, sectionId).then(function (doc) {
      var newGrid = doc.querySelector('.cp-grid');
      var newNav = doc.querySelector('[data-cp-nav]');

      if (loadMore && grid && newGrid) {
        grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      } else if (pageLink && grid && newGrid) {
        grid.innerHTML = newGrid.innerHTML;
      }

      if (newNav) {
        if (nav) nav.replaceWith(newNav);
        else if (section) section.appendChild(newNav);
      }

      pushHistory(url);

      if (pageLink && section) {
        var top = section.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }).catch(function () {
      window.location.href = url;
    }).finally(function () {
      var n = section.querySelector('[data-cp-nav]');
      if (n) n.classList.remove('is-loading');
    });
  });

  /* ── Gallery: horizontal infinite slider (per-device) ── */
  function initGalleries(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var galleries = scope.querySelectorAll('.cp-gallery.gallery-d, .cp-gallery.gallery-m');
    for (var gi = 0; gi < galleries.length; gi++) {
      (function (g) {
        var track = g.querySelector('.cp-grid--gallery');
        if (!track) return;
        function activeNow() {
          var isDesktop = window.matchMedia('(min-width: 750px)').matches;
          return isDesktop ? g.classList.contains('gallery-d') : g.classList.contains('gallery-m');
        }
        if (!track.dataset.cpGalleryInit) {
          track.dataset.cpGalleryInit = '1';
          var cards = Array.prototype.slice.call(track.querySelectorAll('.cp-card-wrap:not(.cp-card-wrap--clone)'));
          if (cards.length === 0) return;
          function cleanClone(node) {
            var c = node.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.classList.add('cp-card-wrap--clone');
            var f = c.querySelector('form[id]');
            if (f) f.removeAttribute('id');
            return c;
          }
          cards.forEach(function (c) { track.appendChild(cleanClone(c)); });
          cards.forEach(function (c) { track.insertBefore(cleanClone(c), track.firstChild); });
        }
        function oneThird() { return track.scrollWidth / 3; }
        function recenter() { track.scrollLeft = activeNow() ? oneThird() : 0; }
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking || !activeNow()) return;
          ticking = true;
          requestAnimationFrame(function () {
            var total = track.scrollWidth;
            var L = total / 3;
            if (track.scrollLeft >= 2 * L) track.scrollLeft -= L;
            else if (track.scrollLeft <= 0) track.scrollLeft += L;
            ticking = false;
          });
        }, { passive: true });
        function step(dir) {
          var all = track.querySelectorAll('.cp-card-wrap:not(.cp-card-wrap--clone)');
          var c0 = all[0], c1 = all[1];
          var w = c0.getBoundingClientRect().width;
          var gap = c1 ? (c1.offsetLeft - c0.offsetLeft - w) : 0;
          track.scrollBy({ left: dir * (w + gap), behavior: 'smooth' });
        }
        var prev = g.querySelector('[data-cp-gallery-prev]');
        var next = g.querySelector('[data-cp-gallery-next]');
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); if (activeNow()) step(-1); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); if (activeNow()) step(1); });
        recenter();
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(recenter, 200);
        });
      })(galleries[gi]);
    }
  }
  var cpQuickAddBound = false;
  function initQuickAdd() {
    if (cpQuickAddBound) return;
    cpQuickAddBound = true;
    // Delegated handler: covers original cards AND gallery clones (added later)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form.cp-quick-form')) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var btnText = btn.querySelector('.cp-btn__text');
      var btnTextOrig = btnText ? btnText.textContent : '';
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (btnText) btnText.textContent = 'Added to cart';
      var section = form.closest('.cp-collection-grid') || document;
      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json().catch(function () { return null; });
        })
        .then(function () {
          showCartToast(section);
          updateCartCount();
        })
        .catch(function () { /* no-op */ })
        .finally(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          if (btnText) btnText.textContent = btnTextOrig;
        });
    });
  }

  function showCartToast(section) {
    var toast = section.querySelector('.cp-cart-toast');
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    if (window.__cpToastTimer) clearTimeout(window.__cpToastTimer);
    window.__cpToastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 320);
    }, 4000);
  }

  function updateCartCount() {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
          if (n == null) return;
          // Generic hook for themes/apps that expose data-cart-count
          Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
            el.textContent = n;
          });
          // Dawn-compatible header cart-count-bubble
          var bubble = document.querySelector('.cart-count-bubble');
          if (!bubble && n > 0) {
            var link = document.getElementById('cart-icon-bubble') || document.querySelector('a[href*="/cart"]');
            if (link) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              bubble.innerHTML = '<span aria-hidden="true">' + n + '</span>';
              link.appendChild(bubble);
            }
          }
          if (bubble) {
            var numSpan = bubble.querySelector('span:not(.cart-count-bubble--overflow)');
            if (numSpan) numSpan.textContent = n;
            bubble.style.display = n > 0 ? '' : 'none';
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGalleries(document);
    initQuickAdd();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initGalleries(e.target);
    initQuickAdd();
  });


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
